import styled from "styled-components";

export const StyledBox = styled.div` 
  display: flex;
  align-items: center;
  padding: 0px;
  /* border-radius: 5px; */
  transition: all 0.5s ease, background-color 0.5s ease;
  cursor: pointer;
  // border:1px solid #0D2957;
padding: 4px;
  &:hover {
    transform: scale(1.1);
    background-color: #0D2957;
    padding: 4px;
  }

  svg {
    transition: all 0.5s ease;
     color: #fff;
     /* fill:#fff; */
     width:1.5rem;
     height:1.5rem;
  }

  &:hover svg {
    transform: rotate(-20deg) scale(1.2);
  }
`;